module.exports = __webpack_public_path__ + "img/電気回路_5_2.17224755.png";